"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubRisqueRendementCorporation = void 0;
exports.ESubRisqueRendementCorporation = {
    null: "null",
    faible: "faible",
    moyen: "moyen",
    eleve: "eleve",
};
